export const getSmsFactorStatus = state => state.smsFactor.status;
export const getSmsFactorPhoneNumber = state => state.smsFactor.phoneNumber;
